import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

import { BusinessPartnerTableFilterSchema } from "./-zod-schema";

export const Route = createFileRoute("/_staff/business-partner/_list/")({
  validateSearch: zodValidator(BusinessPartnerTableFilterSchema),
});
